import PropTypes from 'prop-types';

export default {
  // base url for react-router history
  basename: PropTypes.string,

  // root path from where the widget is hosted (and where static files are found)
  widgetPath: PropTypes.string,

  // prefix path (string) or paths (object) for backend api, default ''
  apiPath: PropTypes.string,

  // default api prefix path, required for endpoints that are configured under SERVICE_DEFAULT
  defaultApi: PropTypes.string,

  // locale
  locale: PropTypes.string
};
